"use strict";
'use es6';

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.restoreView = exports.RestoreView = exports.RestoreViewActionTypes = exports.permanentlyDeleteView = exports.PermanentlyDeleteView = exports.PermanentlyDeleteViewActionTypes = exports.deleteView = exports.DeleteView = exports.DeleteViewActionTypes = exports.updateView = exports.UpdateView = exports.UpdateViewActionTypes = exports.addView = exports.AddView = exports.AddViewActionTypes = exports.stageRestoreView = exports.stageRemoveView = exports.stageUpdateView = exports.stageAddView = exports.loadViews = exports.FetchViews = exports.FetchViewsActionTypes = exports.AnalyticsViewsActionTypes = void 0;

var _extends2 = _interopRequireDefault(require("@babel/runtime/helpers/extends"));

var _I18n = _interopRequireDefault(require("I18n"));

var _fluxActions = require("flux-actions");

var _namespacedKeyMirror = _interopRequireDefault(require("settings-ui-lib/utils/namespacedKeyMirror"));

var _actions = require("settings-ui-lib/utils/actions");

var _RequestStatusTypes = _interopRequireDefault(require("settings-ui-lib/constants/RequestStatusTypes"));

var AnalyticsViewsActionTypes = (0, _namespacedKeyMirror.default)({
  FETCH_VIEWS: null,
  STAGE_ADD_VIEW: null,
  STAGE_UPDATE_VIEW: null,
  STAGE_REMOVE_VIEW: null,
  STAGE_RESTORE_VIEW: null,
  ADD_VIEW: null,
  UPDATE_VIEW: null,
  DELETE_VIEW: null,
  PERMANENTLY_DELETE_VIEW: null,
  RESTORE_VIEW: null
}, 'analytics-and-tracking');
exports.AnalyticsViewsActionTypes = AnalyticsViewsActionTypes;
var FetchViewsActionTypes = (0, _actions.createRequestTypes)(AnalyticsViewsActionTypes.FETCH_VIEWS);
exports.FetchViewsActionTypes = FetchViewsActionTypes;
var FetchViews = (0, _actions.createRequestActions)(FetchViewsActionTypes);
exports.FetchViews = FetchViews;
var loadViews = (0, _fluxActions.createAction)(AnalyticsViewsActionTypes.FETCH_VIEWS);
exports.loadViews = loadViews;
var stageAddView = (0, _fluxActions.createAction)(AnalyticsViewsActionTypes.STAGE_ADD_VIEW, function (view) {
  return view;
});
exports.stageAddView = stageAddView;
var stageUpdateView = (0, _fluxActions.createAction)(AnalyticsViewsActionTypes.STAGE_UPDATE_VIEW, function (view) {
  return view;
});
exports.stageUpdateView = stageUpdateView;
var stageRemoveView = (0, _fluxActions.createAction)(AnalyticsViewsActionTypes.STAGE_REMOVE_VIEW, function (view) {
  return view;
});
exports.stageRemoveView = stageRemoveView;
var stageRestoreView = (0, _fluxActions.createAction)(AnalyticsViewsActionTypes.STAGE_RESTORE_VIEW, function (view) {
  return view;
}); //Below actions are fired as a result of saving staged changes, and should not be used manually

exports.stageRestoreView = stageRestoreView;
var AddViewActionTypes = (0, _actions.createRequestTypes)(AnalyticsViewsActionTypes.ADD_VIEW);
exports.AddViewActionTypes = AddViewActionTypes;
var AddView = (0, _actions.createRequestActions)(AddViewActionTypes, {
  failureMetaCreator: function failureMetaCreator(error) {
    var message = _I18n.default.text('analyticsAndTracking.saved.error.creatingView.message');

    if (error && error.responseJSON && error.responseJSON.message) {
      message = _I18n.default.text('analyticsAndTracking.saved.error.creatingView.withWarning', {
        message: error.responseJSON.message
      });
    }

    return (0, _extends2.default)({}, (0, _actions.createRequestStatusMeta)(AnalyticsViewsActionTypes.base, _RequestStatusTypes.default.FAILED), (0, _actions.createDangerNotificationMeta)(message));
  }
});
exports.AddView = AddView;
var addView = (0, _fluxActions.createAction)(AnalyticsViewsActionTypes.ADD_VIEW, function (view) {
  return view;
});
exports.addView = addView;
var UpdateViewActionTypes = (0, _actions.createRequestTypes)(AnalyticsViewsActionTypes.UPDATE_VIEW);
exports.UpdateViewActionTypes = UpdateViewActionTypes;
var UpdateView = (0, _actions.createRequestActions)(UpdateViewActionTypes, {
  failureMetaCreator: function failureMetaCreator(error) {
    var message = _I18n.default.text('analyticsAndTracking.saved.error.updatingView.message');

    if (error && error.responseJSON && error.responseJSON.message) {
      message = _I18n.default.text('analyticsAndTracking.saved.error.updatingView.withWarning', {
        message: error.responseJSON.message
      });
    }

    return (0, _extends2.default)({}, (0, _actions.createRequestStatusMeta)(AnalyticsViewsActionTypes.base, _RequestStatusTypes.default.FAILED), (0, _actions.createDangerNotificationMeta)(message));
  }
});
exports.UpdateView = UpdateView;
var updateView = (0, _fluxActions.createAction)(AnalyticsViewsActionTypes.UPDATE_VIEW, function (view) {
  return view;
});
exports.updateView = updateView;
var DeleteViewActionTypes = (0, _actions.createRequestTypes)(AnalyticsViewsActionTypes.DELETE_VIEW);
exports.DeleteViewActionTypes = DeleteViewActionTypes;
var DeleteView = (0, _actions.createRequestActions)(DeleteViewActionTypes, {
  failureMetaCreator: function failureMetaCreator(error) {
    var message = _I18n.default.text('analyticsAndTracking.saved.error.deletingView.message');

    if (error && error.responseJSON && error.responseJSON.message) {
      message = _I18n.default.text('analyticsAndTracking.saved.error.deletingView.withWarning', {
        message: error.responseJSON.message
      });
    }

    return (0, _extends2.default)({}, (0, _actions.createRequestStatusMeta)(AnalyticsViewsActionTypes.base, _RequestStatusTypes.default.FAILED), (0, _actions.createDangerNotificationMeta)(message));
  }
});
exports.DeleteView = DeleteView;
var deleteView = (0, _fluxActions.createAction)(AnalyticsViewsActionTypes.DELETE_VIEW, function (view) {
  return view;
});
exports.deleteView = deleteView;
var PermanentlyDeleteViewActionTypes = (0, _actions.createRequestTypes)(AnalyticsViewsActionTypes.PERMANENTLY_DELETE_VIEW);
exports.PermanentlyDeleteViewActionTypes = PermanentlyDeleteViewActionTypes;
var PermanentlyDeleteView = (0, _actions.createRequestActions)(PermanentlyDeleteViewActionTypes, {
  failureMetaCreator: function failureMetaCreator(error) {
    var message = _I18n.default.text('analyticsAndTracking.saved.error.deletingView.message');

    if (error && error.responseJSON && error.responseJSON.message) {
      message = _I18n.default.text('analyticsAndTracking.saved.error.deletingView.withWarning', {
        message: error.responseJSON.message
      });
    }

    return (0, _extends2.default)({}, (0, _actions.createRequestStatusMeta)(AnalyticsViewsActionTypes.base, _RequestStatusTypes.default.FAILED), (0, _actions.createDangerNotificationMeta)(message));
  }
});
exports.PermanentlyDeleteView = PermanentlyDeleteView;
var permanentlyDeleteView = (0, _fluxActions.createAction)(AnalyticsViewsActionTypes.PERMANENTLY_DELETE_VIEW, function (view) {
  return view;
});
exports.permanentlyDeleteView = permanentlyDeleteView;
var RestoreViewActionTypes = (0, _actions.createRequestTypes)(AnalyticsViewsActionTypes.RESTORE_VIEW);
exports.RestoreViewActionTypes = RestoreViewActionTypes;
var RestoreView = (0, _actions.createRequestActions)(RestoreViewActionTypes, {
  failureMetaCreator: function failureMetaCreator(error) {
    var message = _I18n.default.text('analyticsAndTracking.saved.error.restoringView.message');

    if (error && error.responseJSON && error.responseJSON.message) {
      message = _I18n.default.text('analyticsAndTracking.saved.error.restoringView.withWarning', {
        message: error.responseJSON.message
      });
    }

    return (0, _extends2.default)({}, (0, _actions.createRequestStatusMeta)(AnalyticsViewsActionTypes.base, _RequestStatusTypes.default.FAILED), (0, _actions.createDangerNotificationMeta)(message));
  }
});
exports.RestoreView = RestoreView;
var restoreView = (0, _fluxActions.createAction)(AnalyticsViewsActionTypes.RESTORE_VIEW, function (view) {
  return view;
});
exports.restoreView = restoreView;